import {
  State,
  appLogout,
  injectSlice,
  createSlice,
  createAsyncThunk,
  selectAuthenticationStatus,
} from '@betty/toolkit/state';
import BannerService from '../services/BannersService';
import { BannersState } from './banners.types';

const initialState: BannersState = {
  data: [],
  dataState: 'idle',
};

export const fetchBanners = createAsyncThunk(
  'banners/fetch',
  async (_, thunkApi) => {
    const response =
      selectAuthenticationStatus(<State>thunkApi.getState()) === 'authenticated'
        ? await BannerService.getBanners()
        : await BannerService.getPublicBanners();

    return response.banners;
  },
);

const banners = createSlice({
  name: 'banners',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBanners.pending, (state) => {
      state.dataState = 'pending';
    });
    builder.addCase(fetchBanners.fulfilled, (state, action) => {
      state.dataState = 'fulfilled';
      state.data = action.payload;
    });
    builder.addCase(fetchBanners.rejected, (state) => {
      state.dataState = 'rejected';
    });
    builder.addCase(appLogout, () => {
      return initialState;
    });
  },
});

export const withBanners = injectSlice({
  reducerPath: 'banners',
  reducer: banners.reducer,
});

export const selectUserBanners = withBanners.selector(
  (state) => state.banners.data,
);

export const selectBannersDataState = withBanners.selector(
  (state) => state.banners.dataState,
);

declare global {
  interface LazyLoadedSlices {
    banners: ReturnType<typeof banners.reducer>;
  }
}
